// If this state becomes long term, we should clean up the logic around MAX_PRICE_MARKER_COUNT (i.e. the logic for showing black dots)
export const MAX_PRICE_MARKER_COUNT = 35;
